import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge, Button, Empty, Flex, List, Popover, Space, Tooltip, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import notificationService from 'v2/services/notifications';
import webNotificationService from 'v2/services/webNotification';

import Topbar from '@eduzz/ui-layout/Topbar';

import BankslipGenerated from './bankslipGenerated';
import HighChargebackRate from './chargebackRateAboveBlockLimit';
import Comission from './comission';
import { Dispute } from './dispute';
import ProductApproved from './productApproved';
import ProductReproved from './productReproved';
import Refund from './Refund';
import Report from './report';
import ReportNoData from './reportNoData';
import Sales from './sales';
import Subscriptions from './subscriptions';

export default function Notifications() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);
  const [lastUpdate] = useObservable(() => notificationService.getLastUpdate(), []);
  const [popoverOpen, setPopoverOpen] = React.useState(false);
  const permissionDenied = webNotificationService.permission === 'denied';

  useEffect(() => webNotificationService.requestPermission(), []);

  const handleClose = useCallback(() => {
    setPopoverOpen(false);
  }, []);

  const total = (notifications || []).reduce((total, notification) => total + notification.quantity, 0);

  const popoverContent = (
    <List
      className='min-w-70'
      header={
        <Flex align='center' justify='center' id='notification_popover'>
          <Space>
            <Typography.Text strong>Notificações</Typography.Text>
            <Tooltip
              title={
                permissionDenied
                  ? 'Notificações do navegador estão desativadas'
                  : 'Notificações do navegador estão ativadas'
              }
              placement='top'
            >
              {permissionDenied ? <Icon.BellOff  /> : <Icon.Bell  />}
            </Tooltip>
          </Space>
        </Flex>
      }
      footer={
        <Flex align='center' justify='space-between'>
          <Button type='text' icon={<Icon.History  />} disabled>
            {lastUpdate}
          </Button>
          <Link to='/producer/notifications?readAll=true'>
            <Tooltip title='Ao exibir todas notificações todos contadores serão limpos' placement='bottom'>
              <Button type='text' onClick={handleClose}>
                Exibir tudo
              </Button>
            </Tooltip>
          </Link>
        </Flex>
      }
    >
      {!total ? (
        <List.Item>
          <Empty className='w-full' image={Empty.PRESENTED_IMAGE_SIMPLE} description='Não há notificações' />
        </List.Item>
      ) : (
        <Flex vertical onClick={handleClose}>
          <Refund />
          <Dispute />
          <Sales />
          <BankslipGenerated />
          <ProductApproved />
          <ProductReproved />
          <Report />
          <ReportNoData />
          <Comission />
          <HighChargebackRate />
          <Subscriptions />
        </Flex>
      )}
    </List>
  );

  return (
    <Popover
      open={popoverOpen}
      onOpenChange={setPopoverOpen}
      content={popoverContent}
      zIndex={999}
      trigger='click'
    >
      <Topbar.Action
        id='topbar-action-notifications'
        aria-label='mostrar notificações'
        icon={<Icon.Bell />}
        tooltip='Notificações'
        badgeCount={total}
      />
    </Popover>
  );
}
